import { IAssetAlertSummaryResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import { BaseDataSourceOptions } from 'custom_hooks/data_hooks/data_source/data_source';
import { useInfiniteDataSource } from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { toDataSourceResult } from 'utils/query_v3';

export type LocationAssetsWithAlertsFilter = {
    locationId: string;
};

export type UseLocationAssetsWithAlertsDataSourceOptions = BaseDataSourceOptions<
    IAssetAlertSummaryResponse,
    LocationAssetsWithAlertsFilter
>;

async function getAssetsWithAlerts({
    page,
    pageLimit,
    filter,
}: {
    page: number;
    pageLimit: number;
    filter: LocationAssetsWithAlertsFilter;
}) {
    return toDataSourceResult(
        sdClient.getAssetAlertSummariesForLocation({
            locationId: filter.locationId,
            page,
            pageLimit,
        }),
    );
}

export function useLocationAssetsWithAlertsDataSource(
    options: UseLocationAssetsWithAlertsDataSourceOptions,
) {
    return useInfiniteDataSource({
        ...options,
        query: getAssetsWithAlerts,
    });
}
